export function adminRequestHeadersV2(
  init: RequestInit,
  token: string,
  adminSession: string,
): Headers {
  const headers = new Headers(init.headers);
  headers.set("authorization", `Bearer ${token}`);
  if (adminSession) headers.set("x-tradvera-admin-session", adminSession);
  if (typeof init.body === "string" && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  return headers;
}
